"use strict";
/**
 * Copyright (c) Haiku 2016-2018. All rights reserved.
 */
Object.defineProperty(exports, "__esModule", { value: true });
function generateLogger() {
    var CONSOLE_ERRORS = {};
    return function consoleErrorOnce(err) {
        var str = err && err.message.toString();
        if (!CONSOLE_ERRORS[str]) {
            CONSOLE_ERRORS[str] = true;
            console.error(err);
        }
    };
}
exports.default = generateLogger();
//# sourceMappingURL=consoleErrorOnce.js.map